import Template from '../../component/Template.js';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect
import logo from "../../Assets/images/gif/danger.gif";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function SingleFaculty() {
  const [samecoursetypeselectreload, SetsameCourseTypeSelectReload] = useState(false);
  const [collegetype, setCollegetype] = useState(false);
  const [type, setType] = useState(false);

  const [discipline, setDisciplineData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selctedsem, setsem] = useState(1);
  const [getresults, setResults] = useState();
  const [minors, setMinors] = useState([]);
  const [mdc, setMdc] = useState([]);
  const [AEC, setAEC] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);

  const firstRenderRef = useRef(true);

  const [flag, setflag] = useState(false);

  const [current, setCurrent] = useState({

    minor: [],
    mdc: [],
    aec: []
  });

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }


  useEffect(() => {

    const fetchType = async () => {
      try {

        const response2 = await http.get(`/Admin/getCollegeType`);
        setType(response2.data);
        if (response2.data !== "BOTH") {
          setCollegetype(response2.data);
        }

      } catch (error) {

        console.error('Error fetching Course data:', error);
      }
    };

    fetchType();

  }, []);

  useEffect(() => {

      let cid = localStorage.getItem("collegeid");
    const fetchData = async () => {
      try {

        const response2 = await http.get(`/Admin/getSingleFacultyDisciplines`, {
          params: {
            limit: '500',
            college_id: cid,
            college_course_type: collegetype

          }
        });

        if (response2.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response2.data);

        // setSelected(prevSelected => {
        //   const newSelected = response2.data.reduce((acc, option) => {
        //     if (option.selected === 1 && !acc.includes(option.id)) {
        //       return [...acc, option.id];
        //     }
        //     return acc;
        //   }, [...prevSelected]);

        //   return newSelected;
        // });


      } catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
          toast.error(error.response.data.message.message);
        }
        else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Course data:', error);
      }
    };

    if (type === "BOTH" && collegetype !== false) {
      fetchData();
    }
    else if (type === "AIDED" || type === "SF") {
      fetchData();
    }

  }, [type, collegetype, samecoursetypeselectreload]);


  const handlefirstsubmit = () => {

    setFirstSubmit(!isFirstSubmit);
  }
 
  const handleSuccess = async () => {

    setFirstSubmit(!isFirstSubmit);

    const selectedData = {
      minor: current.minor.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      mdc: current.mdc.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
      aec: current.aec.map((course) => ({ course_id: course.course_id, discipline_id: course.discipline_id })),
    };

    try {
      const response = await http.get('/Admin/getCoursegroup');
      const courseGroupData = response.data;

      const courseGroupMap = {};
      courseGroupData.forEach(group => {
        courseGroupMap[group.group_name.toLowerCase()] = group.id;
      });

      const course_group_id = {};
      for (const [key, courses] of Object.entries(selectedData)) {
        if (courses.length > 0) {
          const groupName = key;

          console.log(groupName);

          const groupId = courseGroupMap[groupName];

          if (groupId) {
            if (!course_group_id[groupId]) {
              course_group_id[groupId] = [];
            }
            course_group_id[groupId].push(...courses.map(course => ({ course_id: course.course_id, discipline_id: course.discipline_id })));
          }
        }
      }

      const college_id = localStorage.getItem("collegeid");

      const finalData = {
        college_id: college_id,
        discipline_id: selected,
        semester_id: selctedsem,
        course_group_id,
        college_course_type: collegetype
      };

      console.log('finalData', finalData);

      const saveResponse = await http.post(`/Admin/saveSingleFaculty`, finalData);
      console.log(saveResponse);
      if (saveResponse.data.status_code === "MSG1") {
        toast.success("Updated Successfully");
      }

    } catch (error) {
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response.data.http_status === 422 && error.response.data.status_code == "ERR1") {
        toast.error("Validation Failed");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
        toast.error(error.response.data.message.message);
      } else {
        toast.error("Something went wrong");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }

  };

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const handleType = (selectedOption) => {

    const updatedCurrent = Object.keys(current).reduce((acc, key) => {
      acc[key] = [];
      return acc;
    }, {});

    setCurrent(updatedCurrent);
    setSelected([0]);
    setCollegetype(selectedOption.value);
    SetsameCourseTypeSelectReload(!samecoursetypeselectreload);

  };

  const handleCourseComponentChange = (selectedOptions, field) => {

    setCurrent(prevState => ({
      ...prevState,
      [field]: selectedOptions.map(option => ({
        course_id: option.value,
        course_name: option.label,
        discipline_id: option.discipline_id,
      }))
    }));
  };

  const handleDiscipline = (selectedOptions) => {
    if (!selectedOptions) {

      const updatedCurrent = Object.keys(current).reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});
      setCurrent(updatedCurrent);
      setSelected([0]);
    }
    else {

      const selected = selectedOptions.value;
      setSelected([selected]);
    }

  };

  useEffect(() => {

    if (firstRenderRef.current) {
      firstRenderRef.current = false; // Update the ref to indicate that the first render is done
      return;
    }

    const course_code = async () => {

      let cid = localStorage.getItem("collegeid");
      const discipline_id = selected;
      const semesterid = selctedsem;

      if (discipline_id !== 0 && semesterid && collegetype) {
        try {
          const response = await http.get('/Admin/getSingleFacultyCoursebaskets', {
            params: {
              semester_id: semesterid,
              discipline_ids: discipline_id,
              college_id: cid,
              college_course_type: collegetype
            }
          });

          if (response.data.status_code === 'ERR5') {
            setResults(false);
          }
          else {
            setResults(true);
          }

          setMinors(response.data.minors || []);
          setMdc(response.data.MDC || []);
          setAEC(response.data.AEC || []);

          const selectedMinors = (response.data.minors || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name

            }));

          const selectedMdc = (response.data.MDC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name
            }));

          const selectedAec = (response.data.AEC || []).filter((option) => option.selected === 1)
            .map((option) => ({
              discipline_id: option.discipline_id,
              course_id: option.course_id,
              course_name: option.course_name
            }));

          console.log(selectedMdc, selectedMinors, selectedAec);

          setCurrent(prevState => ({
            ...prevState,
            minor: selectedMinors,
            mdc: selectedMdc,
            aec: selectedAec
          }));


        } catch (error) {
          if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/college/");
            }, 5000);
          }
          else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
            toast.error(error.response.data.message.message);
          }
          else if (error.response.data.status_code === 'ERR5') {
            setResults(false);
          }
          else {
            toast.error("Something went wrong");
          }
          console.error('Error fetching Course data:', error);
        }
      } else {
        toast.error("Select all fields");
      }
    };

    if (selected) {
      course_code();
    }
  }, [selected, selctedsem]);

  const cancelForm = () => {
    window.location.reload();
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>Single Faculty  Course Selection</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="card-body custom-input">
                          <div className="row">
                            <div className="col">
                              <div className="mb-3 row">
                                {type === "BOTH" && (
                                  <div className="col-md-6">
                                    <label className="">Course Type<span className="errorclr">*</span></label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="course_type_id"
                                      name="course_type_id"
                                      styles={customStyles}
                                      className="form"
                                      options={[
                                        { value: 'AIDED', label: 'Aided' },
                                        { value: 'SF', label: 'Self finance' }
                                      ]}
                                      onChange={handleType}
                                    />
                                  </div>
                                )}
                                <div className="col-md-6">
                                  <label className="">Discipline<span className="errorclr">*</span></label>

                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    styles={customStyles}
                                    className="form"

                                    options={flag ? [{ value: '0', label: 'No data found' }] : discipline
                                      .map(disciplines => ({
                                        value: disciplines.id,
                                        label: disciplines.discipline_name
                                      }))

                                    }
                                    value={discipline.filter(disciplines =>
                                      Array.isArray(selected) && selected.some(selecteds => selecteds === disciplines.id)
                                    ).map(selecteds => ({
                                      value: selecteds.id,
                                      label: selecteds.discipline_name
                                    }))}                              

                                    onChange={handleDiscipline}
                                  />
                                </div>
                              </div>
                              <div className="col-md-12">
                                <ul className="nav nav-tabs justify-content-center">
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 1 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(1)}
                                    >
                                      Sem 1
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 2 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(2)}

                                    >
                                      Sem 2
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 3 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(3)}

                                    >
                                      Sem 3
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 4 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(4)}

                                    >
                                      Sem 4
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 5 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(5)}

                                    >
                                      Sem 5
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 6 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(6)}

                                    >
                                      Sem 6
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 7 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(7)}

                                    >
                                      Sem 7
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 8 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(8)}

                                    >
                                      Sem 8
                                    </a>
                                  </li>
                                </ul>


                              </div>

                              <div className="pgm-map-box">
                                <table className="display dataTable table-striped table-bordered">
                                  <tbody>

                                    {minors.length > 0 && getresults === true && (
                                      <tr>
                                        <td>Minors</td>
                                        <td>
                                          <Select
                                            id="minor_select"
                                            name="minor_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={minors.map(minor => ({
                                              value: minor.course_id,
                                              label: minor.course_name,
                                              discipline_id: minor.discipline_id,
                                            }))}
                                            value={current.minor.map(selectedMinor => ({
                                              value: selectedMinor.course_id,
                                              label: selectedMinor.course_name,
                                              discipline_id: selectedMinor.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'minor')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {mdc.length > 0 && getresults === true && (
                                      <tr>
                                        <td>MDC</td>
                                        <td>
                                          <Select
                                            id="mdc_select"
                                            name="mdc_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={mdc.map(mdcs => ({
                                              value: mdcs.course_id,
                                              label: mdcs.course_name,
                                              discipline_id: mdcs.discipline_id
                                            }))}
                                            value={current.mdc.map(selectedMdc => ({
                                              value: selectedMdc.course_id,
                                              label: selectedMdc.course_name,
                                              discipline_id: selectedMdc.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'mdc')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                    {AEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>AEC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={AEC.map(aecs => ({
                                              value: aecs.course_id,
                                              label: aecs.course_name,
                                              discipline_id: aecs.discipline_id
                                            }))}
                                            value={current.aec.map(selectedAec => ({
                                              value: selectedAec.course_id,
                                              label: selectedAec.course_name,
                                              discipline_id: selectedAec.discipline_id
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'aec')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>

                                {selected && getresults ? (
                                  <div className="col-md-12 txt-aln pdg11">
                                    <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                                    <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                                  </div>
                                ) : (
                                  selected.length < 0 && getresults === false ? (
                                    <p className="txt-aln">No data available. Please select Discipline..</p>
                                  ) : (

                                    <p className="txt-aln">No data available..</p>
                                  )
                                )
                                }

                                <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                  <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                      <div className="modal-body">
                                        <div className="modal-toggle-wrapper">
                                          {/* <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul> */}
                                          <h4 className="text-center pb-2">Are you sure you want to proceed?</h4>
                                          <p className="text-center">Any previously saved courses  in the Single Faculty will be deleted, and new courses will be saved under the currently selected course type.</p>
                                          <p className="text-center">Are you sure you want to proceed?</p>
                                          <div className="d-flex justify-content-center mt-3">
                                            <button className="btn btn-danger mx-2" onClick={() => handleSuccess()}>Submit</button>
                                            <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
